export const REGEX = {
  GLOBAL: {
    NOT_HAS_SPECIAL_CHARS: /^[a-zA-ZÀ-ÿ0-9 ]*$/,
    NOT_HAS_DOUBLE_SPACES: /^(?!.* {2,}).*$/
  },

  PRIMITIVES: {
    STRING: {
      ONLY_CHARS: /^[a-zA-ZÀ-ÿ]+$/,
      ONLY_CHARS_WITH_SPACES: /^[a-zA-ZÀ-ÿ ]+$/
    },

    NUMBER: {
      ONLY_NUMBERS: /^[0-9]+$/,
      ONLY_NUMBERS_WITH_SPACES: /^[0-9 ]+$/
    }
  },

  PLATE: /^[A-Z]{3}(?:[0-9]{4}|[0-9][A-Z][0-9]{2})$/,
  RENAVAM: /^[0-9]{11}$/
};
